import React from 'react';
import { PrismicRichText } from '@prismicio/react';
import VideoPlayerComponent from './VideoPlayerComponent';

/**
 * @typedef {import("@prismicio/client").Content.VideoSlice} VideoSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<VideoSlice>} VideoProps
 * @param { VideoProps }
 */
const Video = ({ slice }) => (
  <section>
    <VideoPlayerComponent slice={slice} />
  </section>
);

export default Video;
